import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { bn } from "@opensea/utils";
import { useSubscription } from "../use-subscription";

// High-frequency price subscription
const priceUpdateSubscription = graphql(`
  subscription useCurrencyPriceUpdateSubscription(
    $currency: ContractIdentifierInput!
  ) {
    currencyPriceUpdate(currency: $currency) {
      oneDayCandle {
        time
        open
        high
        low
        close
        volume
      }
      fifteenMinuteCandle {
        time
        open
        high
        low
        close
        volume
      }
      fourHourCandle {
        time
        open
        high
        low
        close
        volume
      }
    }
  }
`);
const swapActivitySubscription = graphql(`
  subscription useCurrencyPriceUpdateSwapActivitySubscription(
    $token: Address!
    $chain: ChainIdentifier!
  ) {
    tokenSwapActivity(token: $token, chain: $chain) {
      timestamp
      fromToken {
        usd
        token {
          unit
          contractAddress
          chain {
            identifier
          }
        }
      }
      toToken {
        usd
        token {
          unit
          contractAddress
          chain {
            identifier
          }
        }
      }
    }
  }
`);
export function useCurrencyPriceUpdateSubscription(contractIdentifier, onPriceUpdate) {
  const $ = _c(19);
  let t0;
  if ($[0] !== contractIdentifier) {
    t0 = contractIdentifier || {
      address: "",
      chain: ""
    };
    $[0] = contractIdentifier;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      currency: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variables = t1;
  const t2 = !contractIdentifier;
  let t3;
  if ($[4] !== t2 || $[5] !== variables) {
    t3 = {
      query: priceUpdateSubscription,
      variables,
      pause: t2
    };
    $[4] = t2;
    $[5] = variables;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onPriceUpdate) {
    t4 = data => {
      const update = data.currencyPriceUpdate;
      onPriceUpdate({
        oneDayCandle: update.oneDayCandle ?? undefined,
        fifteenMinuteCandle: update.fifteenMinuteCandle ?? undefined,
        fourHourCandle: update.fourHourCandle ?? undefined
      });
    };
    $[7] = onPriceUpdate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useSubscription(t3, t4);
  const t5 = contractIdentifier?.address || "";
  const t6 = contractIdentifier?.chain || "";
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = {
      token: t5,
      chain: t6
    };
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !contractIdentifier;
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = {
      query: swapActivitySubscription,
      variables: t7,
      pause: t8
    };
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== contractIdentifier?.address || $[16] !== contractIdentifier?.chain || $[17] !== onPriceUpdate) {
    t10 = data_0 => {
      const relevantTokenPrice = [data_0.tokenSwapActivity.fromToken, data_0.tokenSwapActivity.toToken].find(tokenPrice => tokenPrice.token.chain.identifier === contractIdentifier?.chain && tokenPrice.token.contractAddress === contractIdentifier?.address);
      if (!relevantTokenPrice || relevantTokenPrice.token.unit === 0) {
        return;
      }
      const update_0 = {
        livePrice: {
          value: bn(relevantTokenPrice.usd).dividedBy(relevantTokenPrice.token.unit),
          timestamp: data_0.tokenSwapActivity.timestamp
        }
      };
      onPriceUpdate(update_0);
    };
    $[15] = contractIdentifier?.address;
    $[16] = contractIdentifier?.chain;
    $[17] = onPriceUpdate;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  useSubscription(t9, t10);
}